module.exports = __webpack_public_path__ + "img/bkg-outline-mountains.6e1eb8e0.svg";